/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateRetentionDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { RetentionEntity } from '../models';
// @ts-ignore
import { UpdateRetentionDto } from '../models';
/**
 * RetentionApi - axios parameter creator
 * @export
 */
export const RetentionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new retention
         * @param {CreateRetentionDto} createRetentionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRetention: async (createRetentionDto: CreateRetentionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRetentionDto' is not null or undefined
            assertParamExists('createRetention', 'createRetentionDto', createRetentionDto)
            const localVarPath = `/api/v1.0/retentions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRetentionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a retention
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRetention: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRetention', 'id', id)
            const localVarPath = `/api/v1.0/retentions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all retentions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRetentions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/retentions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get retention by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetentionById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetentionById', 'id', id)
            const localVarPath = `/api/v1.0/retentions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a retention
         * @param {string} id 
         * @param {UpdateRetentionDto} updateRetentionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRetention: async (id: string, updateRetentionDto: UpdateRetentionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRetention', 'id', id)
            // verify required parameter 'updateRetentionDto' is not null or undefined
            assertParamExists('updateRetention', 'updateRetentionDto', updateRetentionDto)
            const localVarPath = `/api/v1.0/retentions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRetentionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RetentionApi - functional programming interface
 * @export
 */
export const RetentionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RetentionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new retention
         * @param {CreateRetentionDto} createRetentionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRetention(createRetentionDto: CreateRetentionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetentionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRetention(createRetentionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a retention
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRetention(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetentionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRetention(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all retentions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRetentions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RetentionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRetentions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get retention by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetentionById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetentionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetentionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a retention
         * @param {string} id 
         * @param {UpdateRetentionDto} updateRetentionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRetention(id: string, updateRetentionDto: UpdateRetentionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetentionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRetention(id, updateRetentionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RetentionApi - factory interface
 * @export
 */
export const RetentionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RetentionApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new retention
         * @param {CreateRetentionDto} createRetentionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRetention(createRetentionDto: CreateRetentionDto, options?: any): AxiosPromise<RetentionEntity> {
            return localVarFp.createRetention(createRetentionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a retention
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRetention(id: string, options?: any): AxiosPromise<RetentionEntity> {
            return localVarFp.deleteRetention(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all retentions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRetentions(options?: any): AxiosPromise<Array<RetentionEntity>> {
            return localVarFp.getAllRetentions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get retention by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetentionById(id: string, options?: any): AxiosPromise<RetentionEntity> {
            return localVarFp.getRetentionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a retention
         * @param {string} id 
         * @param {UpdateRetentionDto} updateRetentionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRetention(id: string, updateRetentionDto: UpdateRetentionDto, options?: any): AxiosPromise<RetentionEntity> {
            return localVarFp.updateRetention(id, updateRetentionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createRetention operation in RetentionApi.
 * @export
 * @interface RetentionApiCreateRetentionRequest
 */
export interface RetentionApiCreateRetentionRequest {
    /**
     * 
     * @type {CreateRetentionDto}
     * @memberof RetentionApiCreateRetention
     */
    readonly createRetentionDto: CreateRetentionDto
}

/**
 * Request parameters for deleteRetention operation in RetentionApi.
 * @export
 * @interface RetentionApiDeleteRetentionRequest
 */
export interface RetentionApiDeleteRetentionRequest {
    /**
     * 
     * @type {string}
     * @memberof RetentionApiDeleteRetention
     */
    readonly id: string
}

/**
 * Request parameters for getRetentionById operation in RetentionApi.
 * @export
 * @interface RetentionApiGetRetentionByIdRequest
 */
export interface RetentionApiGetRetentionByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof RetentionApiGetRetentionById
     */
    readonly id: string
}

/**
 * Request parameters for updateRetention operation in RetentionApi.
 * @export
 * @interface RetentionApiUpdateRetentionRequest
 */
export interface RetentionApiUpdateRetentionRequest {
    /**
     * 
     * @type {string}
     * @memberof RetentionApiUpdateRetention
     */
    readonly id: string

    /**
     * 
     * @type {UpdateRetentionDto}
     * @memberof RetentionApiUpdateRetention
     */
    readonly updateRetentionDto: UpdateRetentionDto
}

/**
 * RetentionApi - object-oriented interface
 * @export
 * @class RetentionApi
 * @extends {BaseAPI}
 */
export class RetentionApi extends BaseAPI {
    /**
     * 
     * @summary Create a new retention
     * @param {RetentionApiCreateRetentionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionApi
     */
    public createRetention(requestParameters: RetentionApiCreateRetentionRequest, options?: AxiosRequestConfig) {
        return RetentionApiFp(this.configuration).createRetention(requestParameters.createRetentionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a retention
     * @param {RetentionApiDeleteRetentionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionApi
     */
    public deleteRetention(requestParameters: RetentionApiDeleteRetentionRequest, options?: AxiosRequestConfig) {
        return RetentionApiFp(this.configuration).deleteRetention(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all retentions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionApi
     */
    public getAllRetentions(options?: AxiosRequestConfig) {
        return RetentionApiFp(this.configuration).getAllRetentions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get retention by ID
     * @param {RetentionApiGetRetentionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionApi
     */
    public getRetentionById(requestParameters: RetentionApiGetRetentionByIdRequest, options?: AxiosRequestConfig) {
        return RetentionApiFp(this.configuration).getRetentionById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a retention
     * @param {RetentionApiUpdateRetentionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetentionApi
     */
    public updateRetention(requestParameters: RetentionApiUpdateRetentionRequest, options?: AxiosRequestConfig) {
        return RetentionApiFp(this.configuration).updateRetention(requestParameters.id, requestParameters.updateRetentionDto, options).then((request) => request(this.axios, this.basePath));
    }
}
